import React from 'react'
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import DrawerHeaderComponent from './DrawerHeaderComponent'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const drawerWidth = 240

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  backgroundColor: '#F6F9FE',
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  backgroundColor: '#F6F9FE',
})

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  boxShadow: 'none',
  border: 'none',
  '& .MuiDrawer-paper': {
    borderRight: 'none',
    borderLeft: 'none',
    boxShadow: 'none',
  },
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      borderRight: 'none',
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      borderRight: 'none',
    },
  }),
}))

const DrawerComponent = ({ open, handleDrawerClose, logos }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const screenModel = useSelector(
    (state) => state?.user?.data?.data?.screenModels
  )

  return (
    <Drawer variant='permanent' open={open} sx={{ border: 'none' }}>
      <DrawerHeaderComponent handleDrawerClose={handleDrawerClose} />
      <Divider sx={{ marginBottom: 1, width: '90%', marginLeft: '5%' }} />
      <List>
        {screenModel?.map(({ name, path }, index) => (
          <ListItem
            key={name}
            disablePadding
            sx={{
              display: 'block',
              color: location.pathname === path ? '#F6764E' : '#F2B9A0',
              fontSize: '16px',
              opacity: location.pathname === path ? '1' : '0.6',
            }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                py: 2,
              }}
              onClick={() => navigate(path)}>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}>
                <Box
                  component='img'
                  src={logos[index]}
                  alt={`Logo ${index + 1}`}
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: location.pathname === path ? '1' : '0.6',
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={name} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  )
}

export default DrawerComponent
